import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { H3_TITLE } from '@Apis/constants';
import ManufacturingOrdersList from './ManufacturingOrdersList';
import './style.scss';

/**
 *
 */
class ManufacturingOrdersHome extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="org-wrapper">
          <ManufacturingOrdersList />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({
});

ManufacturingOrdersHome.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManufacturingOrdersHome));
